import { OperationType } from './operations';

export const URL_HELP_MARKDOWN = 'https://daringfireball.net/projects/markdown/';
export const URL_USER_MANUAL = 'https://documentation.datameer.com/datameer';

const URL_DOC_SNOWFLAKE = 'https://docs.snowflake.com/en';
const URL_DATAMEER_DOT_COM = 'https://www.datameer.com';

export const URL_DOCU_SERVICE_ACCOUNT = `${URL_USER_MANUAL}/initial_setup/#connecting_to_your_snowflake_account`;
export const URL_DOCU_CUSTOM_PROPERTIES = `${URL_USER_MANUAL}/custom_properties/`;
export const URL_DOCU_DEPLOYING_PERMISSIONS = `${URL_USER_MANUAL}/deploying_general_information/#deploying_permissions`;
export const URL_DOCU_SAMPLE_PROJECT = `${URL_USER_MANUAL}/marketing_campaign`;

export const URL_DOCU_SETUP_SLACK = `${URL_USER_MANUAL}/managing_your_slack_integration`;

export const DocuUrlByOperation = {
    [OperationType.BLEND]: `${URL_USER_MANUAL}/light_data_preparation_operations/#join`,
    [OperationType.SUBSTRING_EXTRACT]: `${URL_USER_MANUAL}/light_data_preparation_operations/#extract`,
    [OperationType.FILTER]: `${URL_USER_MANUAL}/light_data_preparation_operations/#filter`,
    [OperationType.PROJECT]: `${URL_USER_MANUAL}/light_data_preparation_operations/#manage_columns`,
    [OperationType.REPLACE]: `${URL_USER_MANUAL}/light_data_preparation_operations/#replace`,
    [OperationType.SPLIT]: `${URL_USER_MANUAL}/light_data_preparation_operations/#split`,
    [OperationType.FORMULA]: `${URL_USER_MANUAL}/light_data_preparation_operations/#formula`,
    [OperationType.AGGREGATE]: `${URL_USER_MANUAL}/light_data_preparation_operations/#aggregate`
};

export const URL_DOC_SNOWFLAKE_ADMIN_ACCOUNT_IDENTIFIER = `${URL_DOC_SNOWFLAKE}/user-guide/admin-account-identifier.html#format-1-preferred-account-name-in-your-organization`;

export const URL_DOC_SNOWFLAKE_COPY_INTO_LOCATION = `${URL_DOC_SNOWFLAKE}/sql-reference/sql/copy-into-location`;
export const URL_DOC_SNOWFLAKE_COPY_INTO_TABLE_COPY_OPTIONS = `${URL_DOC_SNOWFLAKE}/sql-reference/sql/copy-into-table#copy-options-copyoptions`;
export const URL_DOC_SNOWFLAKE_COPY_INTO_TABLE_FORMAT_TYPE_OPTIONS = `${URL_DOC_SNOWFLAKE}/sql-reference/sql/copy-into-table#format-type-options-formattypeoptions`;

export const URL_PRODUCT_PRICING = `${URL_DATAMEER_DOT_COM}/pricing/`;

export const SANDBOX_ACCOUNT_NAME = 'yc17763';
